import React from 'react'
import { ScrollView, StyleSheet, View } from 'react-native'
import { useNavigation, useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { Header, Screen, Text } from '@components'
import { useLanguage } from '@context'

export const PrivacyPolicy: React.FC = () => {
  const theme = useTheme()
  const { t } = useLanguage()
  const navigation = useNavigation()
  const styles = getStyles(theme)

  return (
    <Screen>
      <Header
        title={t('webFooter.privacyPolicy')}
        iconLeft="arrowBack"
        onPressLeft={() => navigation.goBack()}
      />
      <ScrollView style={styles.content} showsVerticalScrollIndicator={false}>
        <View style={styles.section}>
          <Text type="body" color={theme.colors.secondary}>
            {t('privacyPolicy.introduction')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text type="headline" color={theme.colors.black} style={styles.sectionTitle}>
            {t('privacyPolicy.dataCollection')}
          </Text>
          <Text type="body" color={theme.colors.secondary}>
            {t('privacyPolicy.dataCollectionContent')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text type="headline" color={theme.colors.black} style={styles.sectionTitle}>
            {t('privacyPolicy.dataUsage')}
          </Text>
          <Text type="body" color={theme.colors.secondary}>
            {t('privacyPolicy.dataUsageContent')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text type="headline" color={theme.colors.black} style={styles.sectionTitle}>
            {t('privacyPolicy.dataProtection')}
          </Text>
          <Text type="body" color={theme.colors.secondary}>
            {t('privacyPolicy.dataProtectionContent')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text type="headline" color={theme.colors.black} style={styles.sectionTitle}>
            {t('privacyPolicy.cookies')}
          </Text>
          <Text type="body" color={theme.colors.secondary}>
            {t('privacyPolicy.cookiesContent')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text type="headline" color={theme.colors.black} style={styles.sectionTitle}>
            {t('privacyPolicy.rights')}
          </Text>
          <Text type="body" color={theme.colors.secondary}>
            {t('privacyPolicy.rightsContent')}
          </Text>
        </View>
      </ScrollView>
    </Screen>
  )
}

const getStyles = (theme: Theme) =>
  StyleSheet.create({
    content: {
      flex: 1,
      paddingHorizontal: theme.spacing.xl,
    },
    section: {
      marginBottom: theme.spacing.xxl,
    },
    sectionTitle: {
      marginBottom: theme.spacing.sm,
    },
  })
